"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonWithSubActions = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

var button_component_1 = require("./button.component");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.ButtonWithSubActions = utils_2.forwardRef(function ButtonWithSubActions(props, ref) {
  var label = props.label,
      data = props.data,
      width = props.width,
      onSelect = props.onSelect;

  var _a = React.useState(false),
      isDropdown = _a[0],
      setDropdown = _a[1];

  var dropdownRef = React.useRef();
  var container = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
  var arrow = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\twidth: 0.75em;\n\t\theight: 0.75em;\n\t\ttransform: rotate(45deg);\n\t\tposition: absolute;\n\t\tbackground: ", ";\n\t\tmargin-top: -0.31em;\n\t\tmargin-left: 0.938em;\n\t"], ["\n\t\twidth: 0.75em;\n\t\theight: 0.75em;\n\t\ttransform: rotate(45deg);\n\t\tposition: absolute;\n\t\tbackground: ", ";\n\t\tmargin-top: -0.31em;\n\t\tmargin-left: 0.938em;\n\t"])), foundation_1.colors.white);
  var dropdownContainer = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\twidth: ", ";\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: 0.875em;\n\t\tborder-radius: 0.5em;\n\t\tbox-shadow: 0 5px 0.625em rgba(66, 85, 99, 0.25);\n\t\toverflow: auto;\n\t\tcolor: #54666f;\n\t\tz-index: 2;\n\t\tborder: solid 1px #d1d5d8;\n\t"], ["\n\t\twidth: ", ";\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: 0.875em;\n\t\tborder-radius: 0.5em;\n\t\tbox-shadow: 0 5px 0.625em rgba(66, 85, 99, 0.25);\n\t\toverflow: auto;\n\t\tcolor: #54666f;\n\t\tz-index: 2;\n\t\tborder: solid 1px #d1d5d8;\n\t"])), width || '100%');
  var dropdownItem = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tmin-height: 2.875em;\n\t\talign-items: center;\n\t\tpadding: 0 1.5em 0 1.5em;\n\n\t\tborder-bottom: solid 1px ", ";\n\n\t\tcursor: pointer;\n\t\ttransition: all 150ms ease-in-out;\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\ttransition: all 150ms ease-in-out;\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom: solid 1px transparent;\n\t\t}\n\t\t& span {\n\t\t\tmargin-right: 1em;\n\t\t}\n\t"], ["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tmin-height: 2.875em;\n\t\talign-items: center;\n\t\tpadding: 0 1.5em 0 1.5em;\n\n\t\tborder-bottom: solid 1px ", ";\n\n\t\tcursor: pointer;\n\t\ttransition: all 150ms ease-in-out;\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\ttransition: all 150ms ease-in-out;\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom: solid 1px transparent;\n\t\t}\n\t\t& span {\n\t\t\tmargin-right: 1em;\n\t\t}\n\t"])), foundation_1.colors.graphical.strokes, foundation_1.colors.shades.bgLightGrey);

  var onClickAction = function onClickAction() {
    setDropdown(!isDropdown);
  };

  var handleClickOutside = function handleClickOutside(event) {
    var dropDown = dropdownRef.current;

    if (!dropDown) {
      return;
    } // @ts-ignore


    if (!dropDown.contains(event.target)) {
      setDropdown(false);
    }
  };

  React.useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: container
  }, (0, _core.jsx)(button_component_1.Button, {
    label: label,
    onClick: onClickAction,
    noShadow: isDropdown
  }), isDropdown && (0, _core.jsx)(lseds_1.lseds.div, {
    css: dropdownContainer,
    ref: dropdownRef
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: arrow
  }), data && data.map(function (action, i) {
    return (0, _core.jsx)(lseds_1.lseds.div, {
      css: dropdownItem,
      key: "button-action-" + i,
      onClick: function onClick() {
        return onSelect(action.value);
      }
    }, action.icon && (0, _core.jsx)("span", null, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
      icon: action.icon
    })), ' ', action.label);
  })));
});

if (utils_1.isDev) {
  exports.ButtonWithSubActions.displayName = 'ButtonWithSubActions';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;